import type { ToolTestResult } from '../../lib/api';
import { CopyButton } from './CopyButton';
import styles from './ToolTestResult.module.css';

/** The two outcomes that carry an HTTP response (vs. an engine-level error). */
type ResponseResult = Extract<ToolTestResult, { status: 'success' | 'upstream_http_error' }>;

export const ToolTestResponseCard = ({ result }: { result: ResponseResult }) => {
  const isSuccess = result.status === 'success';
  const payload = isSuccess ? result.data : result.body;
  const bodyText = JSON.stringify(payload, null, 2);

  const errorBadgeClass =
    !isSuccess && result.httpStatus < 500 ? styles.warningBadge : styles.errorBadge;
  const badge = isSuccess ? (
    <span className={styles.successBadge}>success</span>
  ) : (
    <span className={errorBadgeClass}>HTTP {result.httpStatus}</span>
  );

  return (
    <section className={styles.card}>
      <header className={styles.cardHeader}>
        <div className={styles.statusGroup}>
          <span className={styles.cardTitle}>Response</span>
          {badge}
        </div>
        <CopyButton value={bodyText} />
      </header>
      <pre className={styles.code}>{bodyText}</pre>
    </section>
  );
};
